module.exports = __webpack_public_path__ + "img/flower-type01-pc.951f5f31.png";